import React, { useState, useEffect } from 'react'
import './styles.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import { isMobile } from '../../../helpers/Mobile';
import { useHistory } from 'react-router-dom';
import useRequest from '../../../hooks/useRequest';
import useDownloadStatus from '../../../hooks/useDownloadStatus';
import { useQuery } from 'hooks/useQuery';
import numberFormatter from '../../../hooks/numberFormatter';

import Table from 'react-bootstrap/Table';


import Api from '../../../services/ApiService';
import Icon from "../Icon";
import Box from "components/atoms/Box";
import GradientButton from "../GradientButton";
import InputCheckbox from '../InputCheckbox';
import FiltroFacturacion from '../FiltroFacturacion';

import DownloadIconButton from '../DownloadIconButton';

const Facturacion = ({ header = 'Facturacion', body = 'Cuerpo', 
        facturas = [{
            "tpo_fac": "NM",
            "comprobante": "FC-0114-19154249",
            "s_periodo": "09-2017",
            "fec_ven": "2017-09-12T00:00:00.000",
            "total_bas": 339.49,
            "s_tot_recargo": 523.86,
            "ajustado": 863.35,
            "pre_com": "0114",
            "num_com": 19154249,
            "fec_emi": "2017-07-13T00:00:00.000",
            "ult_act": "2017-09-12T00:00:00.000",
        }],
        handleCheckbox,
        unidad,
        deudaSeleccionada,
        setDeudaSeleccionada,
        loadingSpinner
}) => {

    const {
        submitted, success, message, errors,
        beforeSubmit, afterSubmit, dealWithError
    } = useRequest();

    const { getStatus, run } = useDownloadStatus();

    const query = useQuery();

    
    const history = useHistory();
    
    const {
        currency
    } = numberFormatter();
    
    const [filtro, setFiltro] = useState("ninguno");
    
    useEffect(() => {
        var wrapper1 = document.getElementById('wrapper1');
        var wrapper2 = document.getElementsByClassName('table-responsive')[0];
        var table = wrapper2.querySelector('.table');
        document.getElementById("div1").style.width = table.offsetWidth;

        wrapper1.onscroll = function () {
            console.log('wrapper1');
            wrapper2.scrollLeft = wrapper1.scrollLeft;
        };
        wrapper2.onscroll = function () {
            console.log('wrapper2');
            wrapper1.scrollLeft = wrapper2.scrollLeft;
        };
    }, []);

    const calcular = (f) => {
        let sum = 0.00;
        sum = facturas.reduce(function (prev, current) {
            if (f === "vencido") {
                console.log("vencido");
                if (current.estado === 'Vencida' && current.seleccionable) {
                    return prev + +current.ajustado
                } else {
                    return prev + +0.00
                }
            }
            if(f === "por-vencer") {
                console.log("por-vencer");
                if (current.estado !== 'Vencida' && current.seleccionable) {
                    console.log('por vecner seleccion');
                    return prev + +current.ajustado        
                } else {
                    return prev + +0.00
                }
            }
            if (f === "todos") {
                console.log("todos");
                if (current.seleccionable){
                    return prev + +current.ajustado
                } else {
                    return prev + +0.00
                }
            }
            if (f === "ninguno") {
                console.log("ninguno");
                if (current.seleccionable) {
                    return 0.00
                } else {
                    return prev + +0.00
                }
            }
        }, 0.00);
        

        if (f === "todos") {
            facturas.map(factura => {
                    if (factura.seleccionable) {
                        factura.isChecked = true
                    }
                    return factura
                }
            );
        }
        if (f === "por-vencer") {
            facturas.map(factura => {
                    if (factura.estado !== 'Vencida' && factura.seleccionable) {
                        factura.isChecked = true
                    } else {
                        factura.isChecked = false
                    }
                    return factura
                }
            );
        }
        if (f === "vencido") {
            facturas.map(factura => {
                if (factura.estado === 'Vencida' && factura.seleccionable) {
                    factura.isChecked = true
                } else {
                    factura.isChecked = false
                }
                return factura
            }
            );
        }
        if (f === "ninguno") {
            facturas.map(factura => {
                if (factura.seleccionable) {
                    factura.isChecked = false
                }
                return factura
            }
            );
        }

        if(sum === undefined){
            sum = 0.00;
        }
        
        setDeudaSeleccionada(sum.toFixed(2));
    }
    
    const descargar = (e, factura) => {
        e.preventDefault();
        run(`${factura.comprobante}|${factura.s_periodo}`, () => Api.openAuthenticatedDownload(
            Api.comprobantePdfUrl(unidad.unidad, factura.comprobante, factura.s_periodo)
        ))
            .catch((error) => {
                dealWithError(error, 'Error al obtener comprobantes');
            });
    };

    const pagosRealizados = (e) => {
        e.preventDefault();

        history.push('/pagos_realizados');
    };

    const pagarAhora = (e) => {
        e.preventDefault();

        history.push('/metodos_pagos');
    };


    return <>
        <Box header='FACTURACIÓN' body={
        <div className="facturacion-box">
            <div className="facturacion-pagos">
                <div className="facturacion-pagos-total">
                    <p>TOTAL DEUDA SELECCIONADA: <strong>{!loadingSpinner && <>$ {currency.format(deudaSeleccionada)}</> }</strong></p>
                    {(deudaSeleccionada > 0.00 && unidad.pagable)  && <GradientButton legend={'PAGAR AHORA'} handleClick={pagarAhora}/> }
                </div>
                <div className="facturacion-pagar-ahora">
                     <GradientButton legend={'PAGOS REALIZADOS'} handleClick={pagosRealizados}/>
                </div>
            </div>
            <div className="dale">
                {success}
                {message}
                {(success === false && message) &&
                    <p className="error-messages">{message}</p>
                }
                {(success === false) &&
                    <p className="error-messages">{errors}</p>
                }
                </div>
                <div className="facturacion-listado" >
                    {unidad.pagable && <FiltroFacturacion filtro={setFiltro} calcular={calcular} facturas={facturas}></FiltroFacturacion>}
                        <div id="wrapper1">
                            <div id="div1">
                            </div>
                        </div>
                        <Table responsive>
                            <thead>
                                <tr>
                                    {!isMobile && <th>TIPO</th>}
                                    <th>FACTURA Nª</th>
                                    <th>PERÍODO</th>
                                    {!isMobile && <th>ESTADO</th>}
                                    <th>FECHA VTO.</th>
                                    {!isMobile && <th className="montos">DEUDA ORIG.</th>}
                                    {!isMobile && <th className="montos">RECARGOS</th>}
                                    <th className="montos">TOTAL</th>
                                    <th></th>
                                </tr>
                            </thead>
                            {!loadingSpinner && <tbody>
                                {facturas.map((factura) => {
                                    if(factura.visible){
                                        return <tr key={factura.comprobante}>
                                            {!isMobile && <td className="tipo" title={factura.tipo_full}>{factura.tpo_com}</td>}
                                            <td>{factura.comprobante}</td>
                                            <td>{factura.s_periodo}</td>
                                            {!isMobile && <td className={factura.estado === 'Vencida' ? 'vencido' : 'a-vencer'} >{factura.estado}</td>}
                                            <td>{factura.fec_ven}</td>
                                            {!isMobile && <td className="montos">$ {currency.format(factura.total_bas)}</td>}
                                            {!isMobile && <td className="montos">$ {currency.format(factura.s_tot_recargo)}</td>}
                                            <td className="montos">$ {currency.format(factura.ajustado)}</td>
                                            <td> 
                                                <InputCheckbox disabled={!factura.seleccionable || !unidad.pagable} value={factura.comprobante} checked={factura.isChecked} handleChange={(e) => handleCheckbox(e, factura.ajustado)} title={!factura.seleccionable || !unidad.pagable ? 'Comprobante No Habilitado para el Pago' : ''} />
                                            </td>
                                            <td>
                                                {factura.descargable && <DownloadIconButton status={getStatus(`${factura.comprobante}|${factura.s_periodo}`)} onClick={(e) => descargar(e, factura)} />}
                                            </td>
                                        </tr>
                                    }
                                    ;
                                })}
                                {facturas.length === 0  && 
                                <p className="messages">No existen facturas para la unidad de facturación</p>
                                }
                        </tbody>}
                        </Table>
            </div>
        </div>
    }>

    </Box>
        <h3 className="facturacion-nota">Nota: En el listado no se informan las facturas adheridas a débito automático. En caso de haber realizado pagos por otros medios, es posible que aún no se encuentren reflejados.<br></br>
            Si el comprobante no se descarga, verifica la configuración de ventanas emergentes y redirecciones del navegador.</h3>
    </>
}

export default Facturacion;